import axios from './financeiroApi';

const regraAutomaticaApi = () => {
  const _PATH = `/api/v1/backend/regra-automatica`;

  return {
    salvar: (regra) => axios.post(_PATH, regra),
    buscarTodos: (filtro) => axios.get(_PATH, { params: filtro }),
    buscar: async (id) => axios.get(`${_PATH}/${id}`),
    atualizar: (regra) => axios.put(`${_PATH}/${regra.id}`, regra),
    excluir: (id) => axios.delete(`${_PATH}/${id}`),
  };
};

export { regraAutomaticaApi };
